import { ReactNode } from "react";
import { persistor } from "../../store";
import { PersistGate } from "redux-persist/integration/react";
import LoadingScreen from "../../stories/components/LoadingScreen/LoadingScreen";

export const ReduxPersistProvider = ({ children }: { children: ReactNode }) => (
  <PersistGate loading={<LoadingScreen />} persistor={persistor}>
    {children}
  </PersistGate>
);
